// API Configuration
export const API_URL = process.env.REACT_APP_API_URL || 'https://api.talaera.com/v1';

// WebRTC Configuration
export const OPENAI_REALTIME_URL = 'https://api.openai.com/v1/realtime';
export const OPENAI_REALTIME_MODEL = 'gpt-realtime';

// Other Configuration
export const DEFAULT_HEADERS = {
  'Content-Type': 'application/json'
}; 